<div class="loader">
    <div id="barra">
        <div id="cadeado"></div>
    </div>
</div>